export enum TrimLocation {
  AroundComponent = 'around-component',
  Component = 'component',
  Corner = 'corner',
  Fascia = 'fascia',
  OnComponent = 'on-component',
  RakeTrim = 'rake-trim',
  RakeTrimLeftSide = 'rake-trim-left-side',
  RakeTrimRightSide = 'rake-trim-right-side',
  Static = 'static',
  SpanPorch = 'span-porch',
}
